import React, { useState, useEffect } from 'react';
import '../CSS/Images.css';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import axios from 'axios'
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import Config from '../Config.json';


function SettingsDialog(props) {
    const [cardsPerQuiz, setCardsPerQuiz] = React.useState(3);
    const [rapidFireTime, setRapidFireTime] = React.useState(10);

    const [oldCardsPerQuiz, setOldCardsPerQuiz] = React.useState(3);
    const [oldRapidFireTime, setOldRapidFireTime] = React.useState(10);
    // const [disableButton, setDisableButton] = React.useState(false);
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
        // console.log("getting userPref")
        getPref();
    }, [])

    function getPref() {
        axios.get(Config.urlStub + "/getUserPref", { withCredentials: true })
        .then((response) => {
          setRapidFireTime(response.data.rapidFireTime);
          setOldRapidFireTime(response.data.rapidFireTime);
          setOldCardsPerQuiz(response.data.cardsPerQuiz);
          setCardsPerQuiz(response.data.cardsPerQuiz);
        }).catch(function (error) {
          console.log(error);
          console.log("getUserPref not ok")
        })
    }

    function updatePref() {
        setOpen(true);

        axios.post(Config.urlStub + "/getUserInfo", 
        {"cardsPerQuiz":cardsPerQuiz, "rapidFireTime":rapidFireTime},
        { withCredentials: true })

        axios.post(Config.urlStub + "/updateUserPref", 
        {"cardsPerQuiz":cardsPerQuiz, "rapidFireTime":rapidFireTime},
        { withCredentials: true })
        .then((response) => {
            setOldCardsPerQuiz(cardsPerQuiz);
            setOldRapidFireTime(rapidFireTime);
        }).catch(function (error) {
          console.log(error);
          console.log("updateUserPref not ok")
        })
    }

    //TODO: useEffect or sth to get user preference
  return (
            <Card sx={{ minWidth: 250}}>
                <CardContent >
                    <Typography>
                        Number of Picture Cards per word
                    </Typography>
                    <Slider
                        sx={{mt:2}}
                        value={cardsPerQuiz}
                        valueLabelDisplay="auto"
                        onChange={(e, val) => setCardsPerQuiz(val)}
                        step={1}
                        min={2}
                        max={5}
                    />
                    <Typography>
                        Rapid Fire Max Time
                    </Typography>
                    <Slider
                        sx={{mt:2}}
                        value={rapidFireTime}
                        onChange={(e, val) => setRapidFireTime(val)}
                        valueLabelDisplay="auto"
                        step={1}
                        min={2}
                        max={10}
                    />
                    <Button 
                    disabled={(oldRapidFireTime === rapidFireTime && cardsPerQuiz === oldCardsPerQuiz)}
                    onClick={updatePref}
                    variant="contained" sx={{width:"100%"}}>Save</Button>
                </CardContent>

                <Snackbar open={open} autoHideDuration={1000} onClose={() => setOpen(false)}
                 anchorOrigin={{horizontal: 'center', vertical: 'bottom'}}>
                    <Alert severity="success" >
                        Setting Saved!
                    </Alert> 
                </Snackbar>
            </Card>
  );
}

export default SettingsDialog;